import React from 'react';

import { PredefinicaoEstiloFormComp } from 'pages/predefinicoes-estilo/components/pages/PredefinicaoEstiloForm';
import { PredefinicoesEstiloListComp } from 'pages/predefinicoes-estilo/components/pages/PredefinicaoEstiloList';
import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';

export function PredefinicoesEstiloList() {
    return (
        <ListagemProvider>
            <PredefinicoesEstiloListComp />
        </ListagemProvider>
    );
}

export function PredefinicaoEstiloForm() {
    return (
        <FormProvider>
            <PredefinicaoEstiloFormComp />
        </FormProvider>
    );
}
